/* eslint-disable global-require */
import React, { useRef, useEffect } from 'react';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';

import './CreditsOverlay.css';
import CloseIcon from '../../img/svg/SchliesszeichenX.svg';

function CreditsOverlay(props) {
  // STATES
  const { handleCreditsModal } = props;

  // EFFECTS
  const creditContainer = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: creditContainer.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: require('../../img/svg/creditanimation_02.json'),
    });
  }, []);

  // RENDER
  return (
    <div className="modal-overlay">
      <div className="modal-close-container">
        <div>
          <button
            type="button"
            className="credits-button"
            onClick={() => handleCreditsModal()}
          >
            <img
              className="modal-close-icon"
              src={CloseIcon}
              width={100}
              alt="Navigation Overlay schließen"
            />
          </button>
        </div>
      </div>
      <div className="modal-content-container">
        <div className="credits-container" ref={creditContainer} />
      </div>
    </div>
  );
}

export default CreditsOverlay;

CreditsOverlay.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  handleCreditsModal: PropTypes.any.isRequired,
};
